<!--
 * @Author: your name
 * @Date: 2021-03-08 16:20:42
 * @LastEditTime: 2022-03-14 14:15:18
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\VdrTools.vue
-->
<template>
  <div class="vdr-tools" id="vdr-tools">
    <!-- <button @click="ratioEdit(0.05)">+</button>
    <button @click="ratioEdit(-0.05)">-</button>-->
    <img class="tool-icon" src="@/assets/images/program/program_enlarge.png" @click="ratioEdit(ratio + 0.05)" alt />
    <img class="tool-icon" src="@/assets/images/program/program_narrow.png" @click="ratioEdit(ratio - 0.05)" alt />
    <img
      class="tool-icon"
      v-for="(tool,index) in toolsList"
      :key="index"
      :src="tool.image"
      @click="attributeValue(tool.command)"
      alt
      :title="$t(tool.i18nTitle)"
      v-show="!(vdrInfor.type === 'look')"
    />
    <!-- <button @click="attributeValue('up')">上</button>
    <button @click="attributeValue('down')">下</button>
    <button @click="attributeValue('ceil')">最上</button>
    <button @click="attributeValue('floor')">最下</button>
    <button @click="attributeValue('full')">全屏满</button>
    <button @click="attributeValue('levelFull')">水平满</button>
    <button @click="attributeValue('verticalFull')">垂直满</button>
    <button @click="attributeValue('downAlign')">底</button>
    <button @click="attributeValue('upAlign')">顶</button>
    <button @click="attributeValue('leftAlign')">左</button>
    <button @click="attributeValue('rightAlign')">右</button>
    <button @click="attributeValue('levelAlign')">垂直中</button>
    <button @click="attributeValue('verticalAlign')">水平中</button>-->
  </div>
</template>

<script>
export default {
  name: 'VdrTools',
  inject: {
    vdrInfor: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    const toolsList = [
      { title: "向上一层", i18nTitle: "PE.OneLayerUp", command: 'up', image: "program_top.png" },
      { title: "向下一层", i18nTitle: "PE.OneLayerDown", command: 'down', image: "program_bottom.png" },
      { title: "最上层", i18nTitle: "PE.Top", command: 'ceil', image: "program_pre.png" },
      { title: "最下层", i18nTitle: "PE.Bottom", command: 'floor', image: "program_behind.png" },
      { title: "全屏铺满", i18nTitle: "PE.Full", command: 'full', image: "program_fullscreen.png" },
      { title: "水平铺满", i18nTitle: "PE.HorizontalFull", command: 'levelFull', image: "program_horscreen.png" },
      { title: "垂直铺满", i18nTitle: "PE.VerticalFull", command: 'verticalFull', image: "program_verticalscreen.png" },
      { title: "垂直向下", i18nTitle: "PE.VerticalDown", command: 'downAlign', image: "program_bottomalign.png" },
      { title: "垂直居中", i18nTitle: "PE.VerticalMiddle", command: 'levelAlign', image: "program_middkealign.png" },
      { title: "垂直向上", i18nTitle: "PE.VerticalTop", command: 'upAlign', image: "program_topalign.png" },
      { title: "水平靠左", i18nTitle: "PE.HorizontalLeft", command: 'leftAlign', image: "program_leftalign.png" },
      { title: "水平居中", i18nTitle: "PE.HorizontalCenter", command: 'verticalAlign', image: "program_centeralign.png" },
      { title: "水平靠右", i18nTitle: "PE.HorizontalRight", command: 'rightAlign', image: "program_rightalign.png" },
    ];
    return {
      vdrWindowW: 0,
      vdrWindowH: 0,
      toolsList
    }
  },
  mounted() {
    this.$nextTick(() => {
      let vdrWindow = document.getElementById("vdr-tools").parentNode.parentNode;
      // console.log(vdrWindow);
      // 41 为工具栏的高度
      let vdrWindowW = vdrWindow.offsetWidth;
      let vdrWindowH = vdrWindow.offsetHeight - 41;
      let vdrw = this.vdrInfor.w;
      let vdrh = this.vdrInfor.h;
      let ratioH = (vdrWindowH * 0.9) / vdrh;
      let ratioW = (vdrWindowW * 0.9) / vdrw;
      let ratio = ratioH < ratioW ? ratioH : ratioW;
      // console.log(1 - ratio);
      // console.log(ratio);
      this.ratioEdit(ratio * 0.9);
      // this.ratioEdit(parseInt(ratio * 100)/100);
    });
    // 导入资源
    this.toolsList.forEach((tool) => {
      tool.image = require("@/assets/images/program/" + tool.image);
    });
  },
  methods: {
    ratioEdit(args) {
      this.$store.commit("RATIO_COUNT", args);
      this.$nextTick(() => {
        window.dispatchEvent(new Event('resize'));
      });
    },
    attributeValue(type) {
      if (this.vdrListLength === 0) {
        return;
      }
      switch (type) {
        case "up": {// 上一层
          this.$store.commit("VDR_WIN_ZINDEX", 1);
        } break;
        case "down": {// 下一层
          this.$store.commit("VDR_WIN_ZINDEX", -1);
        } break;
        case "ceil": {// 最上层
          this.$store.commit("VDR_WIN_CEIL");
        } break;
        case "floor": {// 最下层
          this.$store.commit("VDR_WIN_FLOOR");
        } break;
        case "full": {// 全屏铺满
          this.$store.commit("VDR_WIN_FULL", { x: 0, y: 0, w: this.vdrWindowSize.vdrw, h: this.vdrWindowSize.vdrh });
          this.setStyle('fs', 1);
        } break;
        case "levelFull": {// 水平铺满
          this.$store.commit("VDR_WIN_FULL", { x: 0, w: this.vdrWindowSize.vdrw });
          this.setStyle('fs', 2);
        } break;
        case "verticalFull": {// 垂直铺满
          this.$store.commit("VDR_WIN_FULL", { y: 0, h: this.vdrWindowSize.vdrh });
          this.setStyle('fs', 3);
        } break;
        case "downAlign": {// 垂直向下
          this.$store.commit("VDR_WIN_ALIGN", { y: this.vdrWindowSize.vdrh - this.vdrList[this.vdrIndex].h});
          this.setStyle('va', 1);
        } break;
        case "levelAlign": {// 垂直居中
          this.$store.commit("VDR_WIN_ALIGN", { y: (this.vdrWindowSize.vdrh - this.vdrList[this.vdrIndex].h) / 2 });
          this.setStyle('va', 2);
        } break;
        case "upAlign": {// 垂直向上
          this.$store.commit("VDR_WIN_ALIGN", { y: 0 });
          this.setStyle('va', 3);
        } break;
        case "leftAlign": {// 水平靠左
          this.$store.commit("VDR_WIN_ALIGN", { x: 0 });
          this.setStyle('ha', 1);
        } break;
        case "verticalAlign": {// 水平居中 
          this.$store.commit("VDR_WIN_ALIGN", { x: (this.vdrWindowSize.vdrw - this.vdrList[this.vdrIndex].w) / 2 });
          this.setStyle('ha', 2);
        } break;
        case "rightAlign": {// 水平靠右 
          this.$store.commit("VDR_WIN_ALIGN", { x: this.vdrWindowSize.vdrw - this.vdrList[this.vdrIndex].w});
          this.setStyle('ha', 3);
        } break;
      }
    },
    setStyle(key, val) {
      let wicket = this.vdrList[this.vdrIndex].wicket;
      if (wicket.length === 0) { return; }
      let activeIndex = this.vdrList[this.vdrIndex].activeIndex;
      // this.vdrList[this.vdrIndex].style[key] = val;
      wicket[activeIndex].style[key] = val;
      this.$store.commit("VDR_LIST_EDIT", this.vdrList[this.vdrIndex]);
    }
  },
  computed: {
    vdrList() {
      return this.$store.state.program.vdrList;
    },
    vdrWindowSize() {
      return this.$store.state.program.vdrWindowSize;
    },
    vdrIndex() {
      return this.$store.state.program.vdrIndex;
    },
    ratio() {
      return this.$store.state.program.ratio;
    },
    vdrListLength() {
      return this.$store.getters.getVdrListLength;
    },
  }
}
</script>
<style lang="scss" scoped>
.vdr-tools {
  height: 40px;
  // background: blue;
  border: 1px solid #d7ecf3;
  border-top: 0px solid #d7ecf3;
  display: flex;
  align-items: center;
  overflow-x: auto;
  .tool-icon {
    height: 30px;
    width: 30px;
    margin: 0px 4px;
    border: solid 1px #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
  }
  .tool-icon:hover {
    border: solid 1px #2687fe;
    background-color: #edfbff;
  }
}
</style>